import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GeneralDataComponent} from "./general-data.component";
import {MatLegacyCardModule} from "@angular/material/legacy-card";
import {CtAttachmentManagerService, CtButtonModule, CtFormModule} from "@ctsolution/ct-framework";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatIconModule} from "@angular/material/icon";
import {MatLegacyButtonModule} from "@angular/material/legacy-button";
import {
  WorkOrderImportFileConfigurationDialogModule
} from "../../work-order-import-file-configuration-dialog/work-order-import-file-configuration-dialog.module";
import {WorkOrderAttachmentsService} from './work-order-attachments.service';
import {WorkOrderFileController} from 'projects/ct-manager/src/app/_core/controllers/work-order-file.controller';
import {LeadRedirectButtonModule} from "./lead-redirect-button/lead-redirect-button.module";
import { CompanyService } from '../../../../company/company.service';
import { CompanyContactRelationService } from '../../../../company-contact/company-contact-relation/company-contact-relation.service';
import { WorkOrderDynamicFormModule } from '../work-order-dynamic-form/work-order-dynamic-form.module';
import { WorkOrderCloneModule } from "../../../work-order-clone/work-order-clone.module";
import { WorkOrderCompanyInformationModule } from '../work-order-company-information/work-order-company-information.module';
import { WorkOrderNameChangeWarningDialogModule } from '../work-order-name-change-warning-dialog/work-order-name-change-warning-dialog.module';
import { WorkOrderDuplicateNameDialogModule } from '../work-order-duplicate-name-dialog/work-order-duplicate-name-dialog.module';

@NgModule({
  declarations: [GeneralDataComponent],
  imports: [
    CommonModule,
    MatLegacyCardModule,
    CtFormModule,
    CtButtonModule,
    FlexLayoutModule,
    MatIconModule,
    MatLegacyButtonModule,
    WorkOrderImportFileConfigurationDialogModule,
    LeadRedirectButtonModule,
    WorkOrderDynamicFormModule,
    WorkOrderCloneModule,
    WorkOrderCompanyInformationModule,
    WorkOrderNameChangeWarningDialogModule,
    WorkOrderDuplicateNameDialogModule
  ],
  exports: [GeneralDataComponent],
  providers: [
    WorkOrderFileController,
    WorkOrderAttachmentsService,
    CtAttachmentManagerService,
    CompanyService,
    CompanyContactRelationService
  ]
})
export class GeneralDataModule {
}
